import { useState } from 'react'
import './BackToTop.scss'

const BackToTop = () => {
	const componentClass = 'smart-overlay-back-to-top'

	const minScroll = 50

	const [visible, setVisible] = useState(false)

	const toggleVisible = () => {
		const scrolled = document.documentElement.scrollTop
		if (scrolled > minScroll) {
			setVisible(true)
		} else if (scrolled <= minScroll) {
			setVisible(false)
		}
	}

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
	}

	window.addEventListener('scroll', toggleVisible)

	return (
		<div className={componentClass}>
			<div
				tabIndex={0}
				role="button"
				onClick={scrollToTop}
				style={{
					opacity: visible ? 1 : 0,
					visibility: visible ? 'visible' : 'hidden',
				}}
				className={`${componentClass}--icon`}>
				<i className="cu cu-caret-up"></i>
				<span>Top</span>
			</div>
		</div>
	)
}

export default BackToTop
